export default __webpack_public_path__ + "static/media/tap.0991eba1.svg";